export const SLIDE_PREVIEW_CACHE_PARAM = 'pv';

function parseSlidePreviewUrl(url: string): URL | null {
    try {
        if (/^https?:\/\//i.test(url) || url.startsWith('//')) {
            return new URL(url.startsWith('//') ? `https:${url}` : url);
        }
        if (typeof window !== 'undefined') {
            return new URL(url, window.location.origin);
        }
        return new URL(url, 'https://placeholder.local');
    } catch {
        return null;
    }
}

export function appendSlidePreviewCacheBust(url: string, revision: string | number = Date.now()): string {
    if (!url || url.startsWith('data:')) {
        return url;
    }
    const parsed = parseSlidePreviewUrl(url);
    if (!parsed) {
        const sep = url.includes('?') ? '&' : '?';
        return `${url}${sep}${SLIDE_PREVIEW_CACHE_PARAM}=${encodeURIComponent(String(revision))}`;
    }
    parsed.searchParams.set(SLIDE_PREVIEW_CACHE_PARAM, String(revision));
    if (/^https?:\/\//i.test(url)) {
        return parsed.toString();
    }
    if (url.startsWith('//')) {
        return `//${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
